import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);
document.addEventListener('DOMContentLoaded', function () {
    const testimonialsSliderBlocks = Array.from(document.querySelectorAll('section.testimonials-slider'));
    testimonialsSliderBlocks.forEach(testimonialsSliderBlock => {
        const sliderContainer = testimonialsSliderBlock.querySelector('.swiper-container');
        new Swiper(sliderContainer, {
            slidesPerView: 1.1,
            spaceBetween: 20,
            speed: 500,
            centeredSlides: true,
            slideToClickedSlide: true,
            autoHeight: true,
            threshold: 5,
            breakpoints: {
                768: {
                    slidesPerView: 1.7,
                    spaceBetween: 0,
                    autoHeight: false,
                },
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    });
});
